// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"127":"d9aa5df3","129":"0fd82a5a","555":"3e4befb4","645":"c44e3d1a"}[chunkId] + ".chunk.css";
};